export default __webpack_public_path__ + "static/media/bg_2.88b82c3e.png";